module.exports = __webpack_public_path__ + "static/media/Shift-Bold.cdd38a86.otf";